import React from "react";

export default function ListIcon({ width = "24" }) {
  return (
    <svg className="hover:text-darkblue" xmlns="http://www.w3.org/2000/svg" width={width} height="22" viewBox="0 0 24 22" fill="none">
      <path
        d="M4.6127 0.3125H2.2502C1.3877 0.3125 0.637695 1.025 0.637695 1.925V4.2875C0.637695 5.15 1.3502 5.9 2.2502 5.9H4.6127C5.4752 5.9 6.2252 5.1875 6.2252 4.2875V1.8875C6.1877 1.025 5.4752 0.3125 4.6127 0.3125ZM4.5002 4.175H2.3627V2H4.5002V4.175Z"
        fill="currentColor"
      />
      <path
        d="M9.63789 3.94961H22.5004C22.9504 3.94961 23.3629 3.57461 23.3629 3.08711C23.3629 2.59961 22.9879 2.22461 22.5004 2.22461H9.63789C9.18789 2.22461 8.77539 2.59961 8.77539 3.08711C8.77539 3.57461 9.18789 3.94961 9.63789 3.94961Z"
        fill="currentColor"
      />
      <path
        d="M4.6127 8H2.2502C1.3877 8 0.637695 8.7125 0.637695 9.6125V11.975C0.637695 12.8375 1.3502 13.5875 2.2502 13.5875H4.6127C5.4752 13.5875 6.2252 12.875 6.2252 11.975V9.6125C6.1877 8.7125 5.4752 8 4.6127 8ZM4.5002 11.8625H2.3627V9.6875H4.5002V11.8625Z"
        fill="currentColor"
      />
      <path
        d="M22.5004 9.94922H9.63789C9.18789 9.94922 8.77539 10.3242 8.77539 10.8117C8.77539 11.2992 9.15039 11.6367 9.63789 11.6367H22.5004C22.9504 11.6367 23.3629 11.2617 23.3629 10.8117C23.3629 10.3617 22.9504 9.94922 22.5004 9.94922Z"
        fill="currentColor"
      />
      <path
        d="M4.6127 16.1367H2.2502C1.3877 16.1367 0.637695 16.8492 0.637695 17.7492V20.1117C0.637695 20.9742 1.3502 21.7242 2.2502 21.7242H4.6127C5.4752 21.7242 6.2252 21.0117 6.2252 20.1117V17.7492C6.1877 16.8492 5.4752 16.1367 4.6127 16.1367ZM4.5002 19.9992H2.3627V17.8242H4.5002V19.9992Z"
        fill="currentColor"
      />
      <path
        d="M22.5004 18.0508H9.63789C9.18789 18.0508 8.77539 18.4258 8.77539 18.9133C8.77539 19.4008 9.15039 19.7758 9.63789 19.7758H22.5004C22.9504 19.7758 23.3629 19.4008 23.3629 18.9133C23.3629 18.4258 22.9504 18.0508 22.5004 18.0508Z"
        fill="currentColor"
      />
    </svg>
  );
}
